import PlatformApiClient from '../../libs/platform-api-client';

const productLoaders = {};
const brandLoaders = {};

export default {
  namespaced: true,
  state     : () => ({
    clientId: null,
    brands  : {},
    products: {},
  }),
  mutations: {
    setClientId(state, { clientId }) {
      state.clientId = clientId;
    },
    setProduct(state, { product }) {
      this._vm.$set(state.products, product.product_id, product);
    },
    setBrand(state, { brand }) {
      this._vm.$set(state.brands, brand.id, brand);
    },
  },
  actions: {
    initialize({ commit }, { clientId }) {
      commit('setClientId', { clientId });
    },
    fetchProduct({ commit, state }, { id }) {
      if (!state.clientId) {
        return Promise.reject(new Error('clientId is missing'));
      }
      if (state.products[id]) {
        return Promise.resolve();
      }
      if (productLoaders[id]) {
        return productLoaders[id];
      }

      return productLoaders[id] = new PlatformApiClient(state.clientId, this._vm.$fetch).getProduct(id)
        .then((product) => {
          commit('setProduct', { product });
          productLoaders[id] = undefined;
        })
        .catch((error) => {
          productLoaders[id] = undefined;
          throw error;
        });
    },
    fetchBrand({ commit, state }, { id }) {
      if (!state.clientId) {
        return Promise.reject(new Error('clientId is missing'));
      }
      if (state.brands[id]) {
        return Promise.resolve();
      }
      if (brandLoaders[id]) {
        return brandLoaders[id];
      }

      return brandLoaders[id] = new PlatformApiClient(state.clientId, this._vm.$fetch).getBrand(id)
        .then((brand) => {
          commit('setBrand', { brand });
          brandLoaders[id] = undefined;
        })
        .catch((error) => {
          brandLoaders[id] = undefined;
          throw error;
        });
    },
  },
};
